import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/client";

interface ProjectRow {
  id: string;
  name: string;
  description: string | null;
  repo_owner: string;
  repo_name: string;
  translation_count: number;
}

export function ProjectList() {
  const [projects, setProjects] = useState<ProjectRow[]>([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .listProjects()
      .then((r) => setProjects(r.projects))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const filtered = projects.filter((p) =>
    `${p.name} ${p.repo_owner}/${p.repo_name}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="page">
      <div className="page__header">
        <h1>Projets Shoggoth</h1>
        <Link to="/projects/new" className="btn btn--primary">
          + Ajouter un projet
        </Link>
      </div>

      <input
        className="input"
        placeholder="Rechercher un projet…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {loading && <p>Chargement…</p>}
      {error && <p className="error">{error}</p>}

      <ul className="project-grid">
        {filtered.map((p) => (
          <li key={p.id} className="project-card">
            <Link to={`/projects/${p.id}`}>
              <h2>{p.name}</h2>
              <p className="project-card__repo">
                {p.repo_owner}/{p.repo_name}
              </p>
              {p.description && <p>{p.description}</p>}
              <p className="project-card__meta">{p.translation_count} traduction(s)</p>
            </Link>
          </li>
        ))}
      </ul>

      {!loading && filtered.length === 0 && <p>Aucun projet pour l'instant.</p>}
    </div>
  );
}
